var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('LogoView',{on:{"handleFeedback":_vm.handleFeedback}}),_vm._v(" "),_c('FeedBack',{ref:"feedback",attrs:{"dialogFormVisible":_vm.dialogFormVisible},on:{"cancleFeedback":_vm.cancleFeedback}}),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('app-main')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2ae4d4cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = null
// module chunks = 